import Vue from 'vue';
import Router from 'vue-router';
import Index from '../pages/activity_detail';
import Registration from '../pages/activity_registration';
import baseConfig from '@/config/baseConfig.json';
import {bffClient} from '@/client';

Vue.use(Router);
const prefixPath = '/:languages(no_NO|de_DE|sv_SE|nl_NL|da_DK|en_US)/activity_detail';

const routers = [
  {
    path: `${prefixPath}/index`,
    name: 'index',
    component: Index,
    meta: {
      title: 'Activity Detail',
      keepAlive: false
    },
    props: true
  },
  {
    path: `${prefixPath}/registration`,
    name: 'registration',
    component: Registration,
    meta: {
      title: 'Activity Registration',
      keepAlive: false
    },
    props: true
  }
];

const router = new Router({
  mode: baseConfig.routerModel,
  routes: routers,
  scrollBehavior() {
    return { x: 0, y: 0 };
  }
});

router.beforeEach(async (to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  if (to.name === 'registration') {
    bffClient.getCurrentUserInfo().then(res => {
      next();
    }).catch(err => {
      next(false);
      const { languages = 'no_NO' } = to.params
      location.href = `/${languages}/account/login?redirect_to=${encodeURIComponent(`${to.path}?id=${from.query.id}`)}`;
    });
  }
  next();
});

export { routers, router };
